<div class="popup-overlay" [class.visible]="isOpen" (click)="closePopup($event)">

  <div class="popup-panel" [style.width]="width" [style.height]="height" [class.full-width]="isFullWidth"
    [class.centered-width]="!isFullWidth" (click)="stopPropagation($event)">

    <!-- Close Button -->
    <button *ngIf="showCloseButton" class="popup-close-btn" [class.centered-close]="!isFullWidth"
      (click)="close.emit()">
      ✕
    </button>

    <!-- HEADER (Optional) -->
    <div class="popup-header" *ngIf="hasHeaderContent">
      <ng-content select="[popup-header]"></ng-content>
    </div>

    <!-- BODY -->
    <div class="popup-body">
      <ng-content></ng-content>
    </div>

    <!-- FOOTER (Optional) -->
    <div class="popup-footer" *ngIf="hasFooterContent">
      <ng-content select="[popup-footer]"></ng-content>
    </div>
  </div>
</div>